import { setCookie, getCookie } from "@/utils/cookies";

const COOKIE_NAME = 'cookies-accepted-status';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export const cookiesAccepted = {
  namespaced: true,

  state: {
    status: undefined,
  },

  mutations: {
    retrieveStatus(state) {
      state.status = getCookie(COOKIE_NAME) ?? undefined;
    },
    setStatus(state, status) {
      state.status = status;
      setCookie(COOKIE_NAME, status, {
        maxAge: COOKIE_MAX_AGE
      });
    }
  }
};